// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as InfinityComponent} from './Infinity.svg';

import Icon, { TIconProps } from '../Icon';

export const IconInfinity = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <InfinityComponent/>
  </Icon>
));
